import { SwatchIcon } from "@heroicons/react/24/outline"
import VariantGroupTab from "./VariantGroupTab"

/**
 * Variant group extension (admin side): separate products shown as variants
 * of each other (the colors of a model, each a product of its own). The tab
 * picks or creates the product's group, sets what the product is in it, and
 * lists, adds, removes and opens the group's other products.
 *
 * Named "Variant group", not "Variants": the options extension's Variants grid
 * is the SKUs of one product. The server half is
 * aldoo-na/store/product/extensions/variant-group; the tab works through
 * `store {variant_group}`. The groups themselves are CMS content
 * (StoreProductGroup), edited in the CMS admin.
 */
export const StoreProductExtension = {
  id: "variant-group",
  label: "Variant group",
  description: "Separate products shown as variants of each other (colors): a switcher on each product's page",
  icon: SwatchIcon,
  group: { id: "variant-group", label: "Variant group", description: "The group of separate products this one is a variant of." },
  section: {
    component: VariantGroupTab,
    label: "Variant group",
    icon: SwatchIcon,
    order: 320,
  },
}
